import Cookies from 'js-cookie'
import logger from '@adc/logger'
import { cookies } from '@adc/constants'
import { storeListing } from 'common/actions/listing'
import { initUser, refreshUser } from '../actions/user'
import {
  fetchDataForNewlyAuthenticatedUser,
  fetchGraphUserDetails,
} from '../providers/user'
import { fetchTokenValues } from '../providers/tokenValues'
import { storeFlags } from '../actions/featureFlags'

const fetchDataForNewlyAuthenticatedUserAndTokens = ({
  dispatch,
  listing,
  featureFlags,
  refreshPageData,
}) => {
  const shouldUseRefreshPageData =
    featureFlags['app.enable-pdp-design-2025'] && refreshPageData
  const isRemoteBiddingEnabled =
    featureFlags['fe.resi.enable-web-remote-bidding']
  /**
   * Passing context so that we can apply it when resolving flags (client-side)
   * This mimics the context used in server/index.js.  We can probably ditch gpid SOON!
   */
  if (shouldUseRefreshPageData) {
    refreshPageData()
    // TODO: Create smaller query to just update feature flags.
    // Only leaving it for now beause we still have property in our code
    fetchDataForNewlyAuthenticatedUser(
      listing.listing_id,
      isRemoteBiddingEnabled,
      {
        seller_code: listing?.seller_plan?.seller_plan_code,
      }
    )
      .then(data => {
        let flagForceOverrides = {}
        const flags = data.current_user?.feature_flags || {}
        try {
          flagForceOverrides = Cookies.get(cookies.FEATURE_FLAG_OVERRIDES)
        } finally {
          dispatch(
            storeFlags({
              ...flags,
              ...flagForceOverrides,
            })
          )
        }
      })
      .catch(e =>
        logger.error('Failed to Fetch newly authenticated user data', e)
      )
  } else {
    fetchDataForNewlyAuthenticatedUser(
      listing.listing_id,
      isRemoteBiddingEnabled,
      {
        seller_code: listing?.seller_plan?.seller_plan_code,
      }
    )
      .then(data => {
        let flagForceOverrides = {}
        const flags = data.current_user?.feature_flags || {}
        try {
          flagForceOverrides = Cookies.get(cookies.FEATURE_FLAG_OVERRIDES)
        } finally {
          dispatch(
            storeFlags({
              ...flags,
              ...flagForceOverrides,
            })
          )
          dispatch(storeListing(data.listing))
        }
      })
      .catch(e =>
        logger.error('Failed to Fetch newly authenticated user data', e)
      )
  }
  /**
   * This code addresses the case where an unauthenticated user navigates to
   * the PDP and then authenticates in that tab, getting a new APIAUTH cookie.
   * It doesn't address cases in which the user gets a new APIAUTH token
   * without reloading the page.
   */
  fetchTokenValues(null)
    .then(tokenValues => {
      dispatch(initUser({ tokenValues }))
    })
    .catch(() => {
      logger.error('Failed to fetch token values')
    })
}

export const onAuthenticationComplete =
  ({ user, refreshPageData, listing }) =>
  async (dispatch, getState) => {
    fetchDataForNewlyAuthenticatedUserAndTokens({
      dispatch,
      listing,
      featureFlags: getState().featureFlags,
      refreshPageData,
    })

    let graphUserDetails
    try {
      graphUserDetails = await fetchGraphUserDetails()
    } catch (err) {
      logger.error(err)
    } finally {
      dispatch(
        refreshUser(graphUserDetails?.logged_in ? graphUserDetails : user)
      )
    }
  }
